import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment.svg";
import iFly from "@/assets/ifly.svg";
import LittleExplorers from "@/assets/little-explorers.svg";
import MagicPlanet from "@/assets/magic-planet.svg";
import Snow from "@/assets/snow.svg";
import VoxCinema from "@/assets/vox-cinema.svg";

import ShowsIcon from "@/assets/project-assets/microphone-stand-light-full.svg";
import ShowsIconWhite from "@/assets/project-assets/microphone-stand-light-full-white.svg";
import PavilionsIcon from "@/assets/project-assets/castle-light-full.svg";
import PavilionsIconWhite from "@/assets/project-assets/castle-light-full-white.svg";
import DiningIcon from "@/assets/project-assets/utensils-light-full.svg";
import DiningIconWhite from "@/assets/project-assets/utensils-light-full-white.svg";
import CarnavalIcon from "@/assets/project-assets/ferris-wheel-light-full.svg";
import CarnavalIconWhite from "@/assets/project-assets/ferris-wheel-light-full-white.svg";
import OtherIcon from "@/assets/project-assets/star-light-full.svg";
import OtherIconWhite from "@/assets/project-assets/star-light-full-white.svg";
import FacilitiesIcon from "@/assets/project-assets/restroom-simple-light-full.svg";
import FacilitiesIconWhite from "@/assets/project-assets/restroom-simple-light-full-white.svg";
import RestaurantsIcon from "@/assets/project-assets/plate-utensils-light-full.svg";
import CafesIcon from "@/assets/project-assets/mug-saucer-light-full.svg";
import StreetFoodIcon from "@/assets/project-assets/taco-light-full.svg";
import ToiletIcon from "@/assets/project-assets/restroom-simple-light-full.svg";
import ATMIcon from "@/assets/project-assets/money-from-bracket-light-full.svg";
import BusRTAIcon from "@/assets/project-assets/bus-light-full.svg";
import CareemUberIcon from "@/assets/project-assets/taxi-light-full.svg";
import FirstAidIcon from "@/assets/project-assets/suitcase-medical-light-full.svg";
import GateIcon from "@/assets/project-assets/torii-gate-light-full.svg";
import InformationDeskIcon from "@/assets/project-assets/circle-info-light-full.svg";
import LockerIcon from "@/assets/project-assets/suitcase-light-full.svg";
import LostFoundIcon from "@/assets/project-assets/box-open-light-full.svg";
import MothersRoomIcon from "@/assets/project-assets/person-breastfeeding-light-full.svg";
import NurseryIcon from "@/assets/project-assets/teddy-bear-light-full.svg";
import ParkingIcon from "@/assets/project-assets/square-parking-light-full.svg";
import ParkingIconWhite from "@/assets/project-assets/parking-white.svg";
import PharmacyIcon from "@/assets/project-assets/prescription-bottle-medical-light-full.svg";
import PhoneChargingIcon from "@/assets/project-assets/battery-bolt-light-full.svg";
import PrayerRoomIcon from "@/assets/project-assets/prayer-room.svg";
import RentalServiceIcon from "@/assets/project-assets/moped-light-full.svg";
import SmokingAreaIcon from "@/assets/project-assets/smoking-light-full.svg";
import SupermarketIcon from "@/assets/project-assets/basket-shopping-light-full.svg";
import TaxiIcon from "@/assets/project-assets/taxi-light-full.svg";
import TicketGlobalVillageIcon from "@/assets/project-assets/ticket-light-full.svg";
import TicketCarnavalIcon from "@/assets/project-assets/ticket-perforated-light-full.svg";
import ValetParkingIcon from "@/assets/project-assets/square-parking-light-full.svg";
import { HiOutlineShoppingBag } from "react-icons/hi2";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "shows-events",
    id: "shows-events",
    color: "0,0%,0%",
    iconImage: ShowsIcon,
    iconImageAlt: ShowsIconWhite,
    items: [],
    listed: false,
  },
  {
    title: "pavilions",
    id: "pavilions",
    color: "0,0%,0%",
    iconImage: PavilionsIcon,
    iconImageAlt: PavilionsIconWhite,
    items: [
      {
        title: "pavillions",
        id: [
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:175b16fb-af56-461f-8735-da130639afda",
        ],
        type: "list",
        hideIconUntilSelected: true,
      },
    ],
  },
  {
    title: "shopping",
    id: "shopping",
    color: "0,0%,0%",
    icon: HiOutlineShoppingBag,
    items: [
      {
        title: "shopping",
        id: [
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:ee2ce00c-bfc9-4219-81ba-7b9c2c98855e",
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:73dc59cd-74ec-4d63-8e07-24d09a987b95",
        ],
        type: "list",
        hideIconUntilSelected: true,
      },
    ],
  },
  {
    title: "dining",
    id: "dining",
    color: "0,0%,0%",
    iconImage: DiningIcon,
    iconImageAlt: DiningIconWhite,
    items: [
      {
        title: "restaurants",
        iconImage: RestaurantsIcon,
        id: [
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:3fef5166-f4ac-41b7-b758-7a4bbc154007",
        ],
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "cafes",
        iconImage: CafesIcon,
        id: [
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:1cf4ef88-1218-450f-b4b9-a6a627671758",
        ],
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "street-food",
        iconImage: StreetFoodIcon,
        id: [
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:b06e4ba7-7ca7-408b-9d4b-aebef23f589c",
        ],
        type: "list",
        hideIconUntilSelected: true,
        groupResults: true,
      },
    ],
  },
  {
    title: "carnaval",
    id: "carnaval",
    color: "0,0%,0%",
    iconImage: CarnavalIcon,
    iconImageAlt: CarnavalIconWhite,
    items: [
      {
        title: "carnaval",
        id: [
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:3f1492a8-070d-4484-9db2-2598aa14d649",
        ],
        type: "list",
        hideIconUntilSelected: true,
      },
    ],
  },
  {
    title: "other-attractions",
    id: "other-attractions",
    color: "0,0%,0%",
    iconImage: OtherIcon,
    iconImageAlt: OtherIconWhite,
    items: [
      {
        title: "other-attractions",
        id: [
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:0cbfb2e2-0156-4eb2-b7b0-5c6ada2a068e",
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:abf961fb-f7c3-4d56-a9dd-c47797e27374",
        ],
        type: "list",
        hideIconUntilSelected: true,
      },
    ],
  },
  {
    title: "facilities",
    id: "facilities",
    color: "0,0%,0%",
    iconImage: FacilitiesIcon,
    iconImageAlt: FacilitiesIconWhite,
    items: [
      {
        title: "toilet",
        iconImage: ToiletIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:56ce47e9-9464-4b7f-81e8-ef1e8b8aa80e",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
      },
      {
        title: "atm",
        iconImage: ATMIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:e195522e-3574-46d8-8580-045e607e1c01",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
      },
      {
        title: "bus-rta",
        iconImage: BusRTAIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:a3a085f2-89a6-4c0d-a3ea-7c6aac9b257d",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
      },
      {
        title: "careem-uber",
        iconImage: CareemUberIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:cfadb19b-eb8f-49d6-bdf7-8467a12dc645",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
      },
      {
        title: "first-aid-clinic",
        iconImage: FirstAidIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:24b677d7-cab4-4544-aecf-29a6b7deb4e5",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
      },
      {
        title: "gate",
        iconImage: GateIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:e93b247a-16ad-4a6a-9a09-f0c3469417f0",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
      },
      {
        title: "information-desk",
        iconImage: InformationDeskIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:3e8ff505-bccf-422c-b96d-a2c0693b376f",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
      },
      {
        title: "locker",
        iconImage: LockerIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:ce120f63-348e-43b9-b3eb-6307cfa3eb49",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
      },
      {
        title: "lost-found",
        iconImage: LostFoundIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:5c06fd7b-91b1-41f8-8b61-2356d16089d3",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
      },
      {
        title: "mothers-room",
        iconImage: MothersRoomIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:dec2cb9e-e9d1-40f0-ae40-18059e70ddb2",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
      },
      {
        title: "nursery",
        iconImage: NurseryIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:1d54783b-96de-4c1c-801a-fec2fdd946bc",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
      },
      /*{
        title: "parking",
        iconImage: ParkingIcon,
        id: [
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:127f8b1f-70ab-4f15-ae31-a4ec4fedbcb6",
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:9eb3655d-5461-4149-8544-cfaafd8d2e99",
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:0c396828-a5be-4e59-aebb-298662ff68aa",
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:6b685b33-4dd1-4dfd-b0e4-e2ef86c1eb43",
        ],
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
      },*/
      {
        title: "pharmacy",
        iconImage: PharmacyIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:188d86aa-fe36-4aa1-8dab-79c7b8414a31",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
      },
      {
        title: "phone-charging",
        iconImage: PhoneChargingIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:99c479ba-89d1-4bba-9cb1-e9a3d6370ad0",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
      },
      {
        title: "prayer-room",
        iconImage: PrayerRoomIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:59487043-2bfb-4fe6-ae63-1c4a9cbc140b",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
      },
      {
        title: "rental-service",
        iconImage: RentalServiceIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:79936830-ec8f-4546-9cce-d50731390cd3",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
      },
      {
        title: "smoking-area",
        iconImage: SmokingAreaIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:b315265c-3aba-4625-8b66-e1fb32ec35b8",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
      },
      {
        title: "supermarket",
        iconImage: SupermarketIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:73dc59cd-74ec-4d63-8e07-24d09a987b95",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
      },
      {
        title: "taxi",
        iconImage: TaxiIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:7453d8c9-d45c-4571-8524-6fc272c95345",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
      },
      {
        title: "ticket-global-village",
        iconImage: TicketGlobalVillageIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:1c296727-6285-48a9-b819-0e51f072d47e",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
      },
      {
        title: "ticket-carnaval",
        iconImage: TicketCarnavalIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:fb15488c-eba1-4927-9f09-5288f34ea497",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
      },
      {
        title: "toilet",
        iconImage: ToiletIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:56ce47e9-9464-4b7f-81e8-ef1e8b8aa80e",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
      },
      {
        title: "valet-dropoff",
        iconImage: ValetParkingIcon,
        id: "c50410da-2106-4e69-ba6d-a2c1f738a98b:6b685b33-4dd1-4dfd-b0e4-e2ef86c1eb43",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
      },
      {
        title: "notlistedbuttobehide",
        id: [
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:d0f88e5c-7dfb-4dd2-a4f9-a7c533ae72d9",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "parking",
    id: "parking",
    color: "0,0%,0%",
    iconImage: ParkingIcon,
    iconImageAlt: ParkingIconWhite,
    items: [
      {
        title: "parking",
        id: [
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:127f8b1f-70ab-4f15-ae31-a4ec4fedbcb6",
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:9eb3655d-5461-4149-8544-cfaafd8d2e99",
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:0c396828-a5be-4e59-aebb-298662ff68aa",
          "c50410da-2106-4e69-ba6d-a2c1f738a98b:6b685b33-4dd1-4dfd-b0e4-e2ef86c1eb43",
        ],
        type: "list",
        hideIconUntilSelected: true,
      },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [
  {
    name: "kiosk",
    latitude: 25.21620020891565,
    longitude: 55.40792571152656,
    level: 0,
    pitch: 40,
    bearing: 10,
    zoom: 18,
    poiId:
      "75698d35-0918-4a2b-a8ab-77b93a618e61:c2f3d327-d2ee-4d6f-a14f-2a85dfb1ab8d",
  },
];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "entertainment",
  );
  filterCategories[entertainmentIndex].items = items;
};
